








































import { Component, Vue, Prop } from 'vue-property-decorator';
import RandomGenerator from '@/components/RandomGenerator';
import StatementCheck from '@/components/tools/StatementCheck.vue';

@Component({
  components: {
    StatementCheck,
  },
})

export default class WeightCheck extends Vue {
  @Prop({ required: true })
  level!: number;

  @Prop({ required: true })
  language!: string;

  // eslint-disable-next-line global-require, import/no-dynamic-require
  text = require(`@/text_${this.language}.json`);

  names = ['Mike', 'Jane', 'Kubko', 'Anna', 'Peter', 'Steffi', 'Jan', 'Bea'];

  counter = 0;

  difficultGames = false;

  eachWeightUsed = true; // s1

  multipleWeightUse = true; // s2

  boatOverload = true; // s3

  reloadCounter = 0;

  statements = [[1, this.text.tasks.checkWeights.statements.s1],
    [2, this.text.tasks.checkWeights.statements.s2],
    [3, this.text.tasks.checkWeights.statements.s3]];

  s1 = -1; // user's answer to statement 1

  s2 = -1;

  s3 = -1;

  weights = [1, 2, 3, 4, 5, 6, 7, 8, 10, 12]; // proposed weights

  weightSum = 60; // sum of proposed weights

  boatCapacities = [10, 20, 30];

  actualBoatLoad = [10, 22, 30]; // actual load on each boat

  // actual weight distribution
  rows = [[5, 1, 4, 0, 0], [12, 6, 4, 0, 0], [7, 10, 8, 2, 3]];

  chosenWeights = new Set(this.weights); // weights that are proposed

  actualWeights = new Set(this.weights); // weights that are actually distributed

  beforeMount():void{ // pre-computed function, gets executed when module is loaded/mounted
    this.nextTask();
  }

  // switch answer n to true if false and vice versa
  toggleBox(n:number):void {
    if (n === 1) {
      this.s1 = (this.s1 + 1) % 2;
    } else if (n === 2) {
      this.s2 = (this.s2 + 1) % 2;
    } else if (n === 3) {
      this.s3 = (this.s3 + 1) % 2;
    }
  }

  // set answer n to true
  setTrue(n:number):void {
    if (n === 1) {
      this.s1 = 0;
    } else if (n === 2) {
      this.s2 = 0;
    } else if (n === 3) {
      this.s3 = 0;
    }
  }

  // set answer n to false
  setFalse(n:number):void {
    if (n === 1) {
      this.s1 = 1;
    } else if (n === 2) {
      this.s2 = 1;
    } else if (n === 3) {
      this.s3 = 1;
    }
  }

  // check state of statement n
  checkState(n:number):number {
    if (n === 1) {
      return this.s1;
    }
    if (n === 2) {
      return this.s2;
    }
    return this.s3;
  }

  generateSolution():void {
    this.chosenWeights.clear();
    this.actualWeights.clear();
    let ship1 = 0;
    let ship2 = 0;
    let ship3 = 0;
    const maxWeightSize = 12;
    const max = 60;
    let newWeightSum = 0;
    let chosenWeightSum = 0;

    // choose ship sizes
    if (this.difficultGames) {
      do {
        ship1 = Math.floor(1 + Math.random() * 3) * 10;
        ship2 = Math.floor(1 + Math.random() * 3) * 10;
        ship3 = Math.floor(1 + Math.random() * 3) * 10;
        newWeightSum = ship1 + ship2 + ship3;
      } while (newWeightSum > max);
      this.boatCapacities = [ship1, ship2, ship3];
    } else {
      this.boatCapacities = [20, 20, 20];
      newWeightSum = 60;
    }
    // choose weights
    const sentinel = 4;
    let randomWeight = 0;

    while (chosenWeightSum + sentinel <= newWeightSum || this.chosenWeights.size < 5
    || (!this.difficultGames && this.chosenWeights.size > 7)) {
      chosenWeightSum = 0;
      this.chosenWeights.clear();
      while (chosenWeightSum <= newWeightSum) {
        randomWeight = Math.floor(1 + Math.random() * maxWeightSize);
        if (!this.chosenWeights.has(randomWeight)) {
          this.chosenWeights.add(randomWeight);
          chosenWeightSum += randomWeight;
        }
      }
      this.chosenWeights.delete(randomWeight);
      chosenWeightSum -= randomWeight;
    }

    // add extra weight exceeding boat capacity
    if (chosenWeightSum + randomWeight < newWeightSum + 5 && Math.random() > 0.3) {
      this.chosenWeights.add(randomWeight);
      chosenWeightSum += randomWeight;
    }

    // transform to array
    this.weights = Array.from(this.chosenWeights);
    this.weights.sort((a, b): number => a - b);

    // distribute weights among boats
    const tolerance = 2;

    // iterate through all chosen weights and distribute them
    for (let i = this.weights.length - 1; i >= 0; i -= 1) {
      // distribute weights as well as possible
      for (let j = 0; j < this.boatCapacities.length; j += 1) {
        if (this.weights[i] <= this.boatCapacities[j] - this.actualBoatLoad[j]) {
          this.addWeight(this.weights[i], j);
          this.actualBoatLoad[j] += this.weights[i];
          break;
        }
      }
      // distribute remaining weights even if boat capacity is exceeded
      for (let j = 0; j < this.boatCapacities.length; j += 1) {
        if (this.actualBoatLoad[j] + this.weights[i] <= this.boatCapacities[j] + tolerance
         && !this.actualWeights.has(this.weights[i])
         && !this.boatOverload
         && Math.random() > 0.3) {
          this.addWeight(this.weights[i], j);
          this.actualBoatLoad[j] += this.weights[i];
          break;
        }
      }
    }

    // if boats not yet overloaded, add another random weight
    this.boatOverloadCheck();
    if (!this.boatOverload && Math.random() > 0.3) {
      randomWeight = 1 + Math.floor(Math.random() * (maxWeightSize / 2));
      for (let j = 0; j < this.boatCapacities.length; j += 1) {
        if (this.actualBoatLoad[j] + randomWeight
         <= this.boatCapacities[j] + tolerance) {
          this.addWeight(randomWeight, j);
          this.actualBoatLoad[j] += randomWeight;
          break;
        }
      }
    }
    /*
    // sort weights s.t. its not apparent that a fake weight has been inserted
    for (let i = 0; i < this.rows.length; i += 1) {
      this.rows[i].sort((a, b): number => a - b);
    }
    */

    if (!this.difficultGames) {
      const r = new RandomGenerator();
      this.rows = r.shuffle(this.rows);
    }

    // check if statements are actually true
    this.weightCheck();
    this.boatOverloadCheck();
  }

  // place weight i in boat j
  addWeight(i:number, j:number):void {
    for (let l = 0; l < this.rows[0].length; l += 1) {
      if (this.rows[j][l] === 0 && i !== 0) {
        this.rows[j][l] = i;
        this.actualWeights.add(i);
        return;
      }
    }
  }

  restart(): void {
    this.reloadCounter += 1;
  }

  nextTask():void {
    this.counter = (this.counter + 1) % this.names.length;
    this.restart();
    this.rows = [[0, 0, 0, 0, 0], [0, 0, 0, 0, 0], [0, 0, 0, 0, 0]];
    this.weights = [0];
    this.actualBoatLoad = [0, 0, 0];
    this.generateSolution();
  }

  // check if how many times each weight is used
  weightCheck():void {
    this.actualWeights.clear();
    this.eachWeightUsed = true;
    this.multipleWeightUse = false;

    for (let i = 0; i < this.rows.length; i += 1) {
      for (let j = 0; j < this.rows[0].length; j += 1) {
        if (this.rows[i][j] !== 0) {
          if (this.actualWeights.has(this.rows[i][j])) {
            this.multipleWeightUse = true;
          }
          this.actualWeights.add(this.rows[i][j]);
        }
      }
    }
    for (let i = 0; i < this.weights.length; i += 1) {
      if (!this.actualWeights.has(this.weights[i])) {
        this.eachWeightUsed = false;
      }
    }
  }

  // check if a boat is overloaded
  boatOverloadCheck():void {
    this.boatOverload = false;
    for (let i = 0; i < this.boatCapacities.length; i += 1) {
      if (this.actualBoatLoad[i] > this.boatCapacities[i]) {
        this.boatOverload = true;
        return;
      }
    }
  }

  // check if user's answers are correct
  checkSolution():void {
    const s1sol = this.s1 === 0;
    const s2sol = this.s2 === 0;
    const s3sol = this.s3 === 0;
    if (this.s1 === -1 || this.s2 === -1 || this.s3 === -1) {
      this.$emit('false-solution', this.text.tasks.checkWeights.tips.tip1);
    } else if (s1sol === this.eachWeightUsed
     && s2sol === !this.multipleWeightUse
     && s3sol === !this.boatOverload) {
      this.$emit('correct-solution');
    } else if (s3sol === this.boatOverload) {
      this.$emit('false-solution', this.text.tasks.checkWeights.tips.tip2);
    } else if (s2sol === this.multipleWeightUse) {
      this.$emit('false-solution', this.text.tasks.checkWeights.tips.tip3);
    } else if (s1sol === !this.eachWeightUsed) {
      this.$emit('false-solution', this.text.tasks.checkWeights.tips.tip4);
    }
  }

  switchDifficulty():void {
    this.difficultGames = !this.difficultGames;
    this.nextTask();
  }
}

